<script lang="ts">
  export let direction = "right";
  export let double = false;

  function rotation(direction?: string) {
    if (!direction) {
      return "";
    }

    let deg = "0deg";
    if (direction === "down") {
      deg = "90deg";
    } else if (direction === "left") {
      deg = "180deg";
    } else if (direction === "up") {
      deg = "-90deg";
    } else {
      deg = "0deg";
    }

    return `transform: rotate(${deg}) `;
  }
</script>

{#if direction}
  <i class="arrow" class:double style={rotation(direction)} />
{:else}
  <i class="arrow" class:double />
{/if}

<style lang="scss">
  .arrow {
    display: inline-block;
    width: 1.25em;
    height: 1.25em;
    background: url("./arrow.svg");
    background-size: cover;
  }

  .double {
    background: url("./double.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
</style>
